import { render } from "./AgentManagers.vue?vue&type=template&id=84094f36"
import script from "./AgentManagers.vue?vue&type=script&lang=js"
export * from "./AgentManagers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__